<template>
  <div v-loading="loading">
    <div class="section-header">
      {{ $l('table_label_fileResult') || '文件处理结果' }}
    </div>
    <FileResult :data="fileResult" />

    <div class="section-header mt-3">
      {{ $l('table_label_skuResult') || 'SKU与箱号' }}
    </div>

    <SkuResult
      :amzFtyNoticeOutCode="amzFtyNoticeOutCode"
      :data="skuResult"
      @reload="$emit('reload')"
    />
  </div>
</template>

<script>
import FileResult from './file-result'
import SkuResult from './sku-result'
export default {
  components: { FileResult, SkuResult },
  props: {
    amzFtyNoticeOutCode: { type: String, default: '' },
    listAmzFtyNoticeOutDocCode: { type: Array, default: () => [] },
  },
  data() {
    return {
      data: { results: [], skus: {} },
      loading: false,
    }
  },
  computed: {
    fileResult() {
      return this.data.results || []
    },
    skuResult() {
      const skus = this.data.skus || {}
      return Object.keys(skus).map((sku) => ({
        sku,
        listBoxNo: skus[sku] || [],
      }))
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.listAmzFtyNoticeOutDocCode?.length) return

      this.loading = true
      const res = await this.$api
        .ecomAmzFtyNoticeOutDocReadBoxNoApi({
          listAmzFtyNoticeOutDocCode: this.listAmzFtyNoticeOutDocCode,
        })
        .catch(() => null)
      this.loading = false

      if (!res) return

      const { status, msg, body } = res
      if (status !== 200) {
        this.$message({
          showClose: true,
          message: msg || this.$l('tips_readBox_readFail') || '提取失败！',
          type: 'error',
        })
        return
      }

      this.data = body || {}
    },
    cancel() {
      this.$confirm(
        this.$l('tips_readBox_exitConfirm') ||
          '确认要退出吗？退出后提取的数据将丢失！',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        }
      ).then(() => {
        this.$emit('close')
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.section-header {
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.box-no-list {
  display: flex;
  flex-wrap: wrap;
}
</style>
